import { render } from "./database.svg?vue&type=template&id=dadaf45a?inline"
const script = {}
script.render = render

export default script